// Lab values that only tell the doctor to check the original report.
// They must be replaced with a real outcome before results are transmitted.
const UNRESOLVED_STRING_VALUES = ['seeOriginalReport', 'notSupported'];

const UNRESOLVED_STRING_VALUE_LABELS: { [key: string]: string } = {
  seeOriginalReport: 'See lab result',
  notSupported: 'Not supported',
};

// Tests whose result is always set manually by the doctor
const ALWAYS_MANUAL_TEST_OPTIONS: {
  [testName: string]: { value: string; label: string }[];
} = {
  hepatitisB: [
    { value: 'positive', label: 'Positive' },
    { value: 'negative', label: 'Negative' },
    { value: 'acute', label: 'Acute' },
    { value: 'unclear', label: 'Unclear' },
  ],
  luesScreen: [
    { value: 'positive', label: 'Positive' },
    { value: 'negative', label: 'Negative' },
  ],
  antiHCV: [
    { value: 'positive', label: 'Positive' },
    { value: 'negative', label: 'Negative' },
    { value: 'fault', label: 'Fault' },
  ],
};

interface ManualResultField {
  key: string;
  testName: string;
  parameterName: string;
  initialValue: string;
}

const isUnresolvedStringValue = (value: string | undefined) =>
  value !== undefined && UNRESOLVED_STRING_VALUES.includes(value);

const isManualResultParameter = (
  testName: string,
  stringValue: string | undefined,
) =>
  testName in ALWAYS_MANUAL_TEST_OPTIONS || isUnresolvedStringValue(stringValue);

const getManualResultKey = (testName: string, parameterName: string) =>
  `${testName}.${parameterName}`;

const getManualResultOptions = (testName: string, outcomes: any[] = []) =>
  ALWAYS_MANUAL_TEST_OPTIONS[testName] ||
  outcomes.map((outcome) => ({
    value: outcome.name,
    label: outcome.displayInterpretation,
  }));

const getManualResultEmptyLabel = (stringValue: string | undefined) =>
  (stringValue && UNRESOLVED_STRING_VALUE_LABELS[stringValue]) ||
  'Select result...';

const getManualResultFields = (tests: any[] | undefined) => {
  const fields: ManualResultField[] = [];

  (tests || []).forEach((test: any) => {
    (test.parameters || []).forEach((parameter: any) => {
      if (isManualResultParameter(test.name, parameter.stringValue)) {
        fields.push({
          key: getManualResultKey(test.name, parameter.name),
          testName: test.name,
          parameterName: parameter.name,
          initialValue: isUnresolvedStringValue(parameter.stringValue)
            ? ''
            : parameter.stringValue || '',
        });
      }
    });
  });

  return fields;
};

export {
  getManualResultEmptyLabel,
  getManualResultFields,
  getManualResultKey,
  getManualResultOptions,
  isManualResultParameter,
};
export type { ManualResultField };
